define(['components/utilities/utilities', 'libs/flatpickr'], function (utils, flatpickr) {
	'use strict';

	/**
	 * Datepicker
	 * A plugin that add a datepicker.
	 * @exports datepicker
	 */
	var datepicker = {

		/** An array that will contain all the flatpickr objects. */
		datePickers: [],


		/**
		 * The initialization function for this module.
		 * @param {Object} els - A node list.
		 * @public
		 */
		init: function (els) {
			var that = this;

			this._i18n();

			utils.forEach(els, function (input, i) {
				that._initPicker(input, i);
			});
		},


		/**
		 * Initiate Flatpickr on an input.
		 * @param {Object} input - A input DOM node.
		 * @param {Object} index - An integer for the index of the datepicker.
		 * @private
		 */
		_initPicker: function (input, index) {
			var that = this,
				triggerElement = document.getElementById(input.getAttribute('data-datepicker-trigger'));

			this.datePickers[index] = flatpickr(input, {
				triggerElement: triggerElement,
				timeFormat: 'H:i',
				time_24hr: true
			});
			input.setAttribute('data-datepicker-index', index);

			if (input.getAttribute('data-datepicker-type') === 'from') {
				this.datePickers[index].set('onChange', function (d) {
					var target = document.getElementById(input.getAttribute('data-datepicker-target')),
						datepickerIndex = target.getAttribute('data-datepicker-index');

					that.datePickers[datepickerIndex].set('minDate', d);
				});
			}
			else if (input.getAttribute('data-datepicker-type') === 'to') {
				this.datePickers[index].set('onChange', function (d) {
					var target = document.getElementById(input.getAttribute('data-datepicker-target')),
						datepickerIndex = target.getAttribute('data-datepicker-index');

					that.datePickers[datepickerIndex].set('maxDate', d);
				});
			}

			utils.addEventListener(input, 'keyup', function () {
				if (this.value.length !== 10) {
					return true;
				}

				var date = that._parseISO8601(this.value),
					dateStr = date.toString(),
					picker = that.datePickers[this.getAttribute('data-datepicker-index')],
					selectionStart = input.selectionStart || null,
					lastDate = input.getAttribute('data-last-date');

				if (dateStr !== 'Invalid Date' && dateStr !== 'NaN' && this.value !== lastDate) {
					picker.setDate(date, false);
					input.setAttribute('data-last-date', this.value);

					if (selectionStart !== null) {
						input.setSelectionRange(selectionStart, selectionStart);
					}
				}
			});
		},


		/**
		 * Parses a date in format 'YYYY-mm-dd' to a date object.
		 * @private
		 */
		_parseISO8601: function (dateStringInRange) {
			var isoExp = /^\s*(\d{4})-(\d\d)-(\d\d)\s*$/,
				date = new Date(NaN), month,
				parts = isoExp.exec(dateStringInRange);

			if (parts) {
				month = +parts[2];
				date.setFullYear(parts[1], month - 1, parts[3]);
				if (month != date.getMonth() + 1) {
					date.setTime(NaN);
				}
			}
			return date;
		},


		/**
		 * Adds translations for the flatpickr plugin.
		 * @private
		 */
		_i18n: function () {
			flatpickr.init.prototype.l10n.weekdays.shorthand = ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'];
			flatpickr.init.prototype.l10n.months.longhand = ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'July', 'Augusti', 'September', 'Oktober', 'November', 'December'];
			flatpickr.init.prototype.l10n.firstDayOfWeek = 1; // Monday
		}
	};


	return datepicker;
});


//////////////////
// WEBPACK FOOTER
// ./components/datepicker/datepicker.js
// module id = 22
// module chunks = 7